import React from 'react';
import { func, bool, node } from 'prop-types';
import { Box, Button } from '@mui/material';
import { Spinner } from '../../../../../../../../components';

const staticText = {
  buttonVerify: 'Verify this webhook',
  buttonExit: 'Do this later',
};

const Unverified = ({
  toggleModal,
  handleWebhookVerify,
  isVerifyingWebhook,
  verifyAttempted,
  feedback,
  sharedTitle,
  sharedLink,
}) => {
  return (
    <div>
      {(verifyAttempted && !isVerifyingWebhook) && feedback}
      {sharedTitle}
      {sharedLink}
      <Box marginTop={2} display="flex" justifyContent="flex-end" gap={1}>
        <Button variant="outlined" color="secondary" onClick={toggleModal} >
          {staticText.buttonExit}
        </Button>
        <Button
          variant="outlined"
          onClick={() => handleWebhookVerify(staticText.buttonVerify)}
          startIcon={isVerifyingWebhook && <Spinner size="button" />}
          disabled={isVerifyingWebhook}
        >
          {staticText.buttonVerify}
        </Button>
      </Box>
    </div>
  );
};

export default Unverified;

Unverified.propTypes = {
  toggleModal: func.isRequired,
  handleWebhookVerify: func.isRequired,
  isVerifyingWebhook: bool.isRequired,
  verifyAttempted: bool.isRequired,
  feedback: node.isRequired,
  sharedTitle: node.isRequired,
  sharedLink: node.isRequired,
};
